/**
 * Mock bundle design for the "Single Wire Shelf" inseparable soft bundle (ISB) choice
 * (catalog choice 280101, see packoutMockData.js). Unlike a single-SKU bundle
 * (Sku set at the design level, e.g. ryobi-wallRail-bundle.mock.js), an ISB design has
 * NO top-level Sku — each part keeps its own individual Sku/ChoiceId and is placed as
 * its own independently-tracked anchor claim, permanently grouped only by the
 * placement-time bundleInstanceId (not by a shared purchase Sku).
 *
 * Each part's real anchor position is DERIVED at placement/drag time from its own
 * Origin (see resolveInseparableBundleAnchorTargets) — no separate AnchorOffset field.
 * The real catalog/BundleDesign backend can never provide one (Origin is the only
 * per-part positioning field it's guaranteed to have, same as every other bundle type),
 * so the resolver converts each part's physical Origin.Column into an anchor-column
 * offset by dividing by the wall-rail's own real anchor spacing (derived from its
 * anchor points' own xPosition) — this mock only needs to supply realistic Origin
 * values, not a pre-computed column count.
 *
 * Placeholder Skus (900000xxx) and mediaUrls — swap for real OMSIDs/images once the
 * catalog team provides them.
 */

const DESIGN_ID = '8f0af0eb-0000-0000-0000-mock00000011';
const BRACKET_CHOICE_ID = 284358; // shared "Shelf Bracket" part choice, hidden from selector
const SHELF_CHOICE_ID = 284360;
const CELL_WIDTH = 330; // centiunits (3.3in), the bracket's own physical width
const WIRE_SHELF_WIDTH = 2100; // centiunits (21in), the wire shelf's own physical width

const CELL_HEIGHT = 380; // centiunits (3.8in)

const designDocument = {
  ModularDesignType: 'WallStorage',
  Id: DESIGN_ID,
  DesignName: 'Single Wire Shelf (mock ISB)',
  Version: 1,
  ProductTypeId: null,
  Sku: null,
  Surface: null,
  Matrix: null,
  Cart: [],
  IsLocked: false,
  ProductsHash: null,
  ProjectId: null,
  Created: '2026-01-01T00:00:00.000Z',
  LastModified: '2026-01-01T00:00:00.000Z',
  Products: [
    {
      InstanceId: 'isb-single-wire-shelf-bracket-left',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      Origin: {
        Row: 0, Column: 0, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 1,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-single-wire-shelf-shelf',
      Type: 'Accessory',
      Sku: 324536604,
      Name: 'Single Wire Shelf (mock)',
      ChoiceId: SHELF_CHOICE_ID,
      // The shelf overlaps HALF of bracket-left's width (it sits on top of/behind the
      // bracket, not butted flush against its edge).
      Origin: {
        Row: 0, Column: CELL_WIDTH / 2, Height: CELL_HEIGHT / 2, Width: WIRE_SHELF_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 2,
      TargetArea: null,
      ChoiceBundle: null,
    },
    {
      InstanceId: 'isb-single-wire-shelf-bracket-right',
      Type: 'Accessory',
      Sku: 324536431,
      Name: 'Shelf Bracket (mock)',
      ChoiceId: BRACKET_CHOICE_ID,
      // Bracket-right's own anchor sits exactly one shelf-width from bracket-left's —
      // it overlaps the shelf's right end by half its own width, mirroring
      // bracket-left's overlap on the left end, so the two halves cancel out and the
      // bracket-to-bracket anchor distance is just WIRE_SHELF_WIDTH (confirmed against
      // real bracket/shelf measurements; NOT bracket-width + shelf-width).
      Origin: {
        Row: 0, Column: WIRE_SHELF_WIDTH, Height: CELL_HEIGHT, Width: CELL_WIDTH,
      },
      ParentIds: null,
      DefaultIds: [],
      ChildrenIds: [],
      Attachment: null,
      Precedence: 3,
      TargetArea: null,
      ChoiceBundle: null,
    },
  ],
};

const wallStorageIsbSingleWireShelfMock = [
  {
    Id: DESIGN_ID,
    DesignDocument: JSON.stringify(designDocument),
  },
];

export default wallStorageIsbSingleWireShelfMock;
